import React, { useEffect, useState } from 'react';
import { exportToExcel } from 'src/utils/Common';
import { Button } from '@material-ui/core';
import {BottomNavigationAction} from '@material-ui/core';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { useTranslation } from 'react-i18next';
import axios from 'src/utils/axios';

function EmployeeExcelExport(JsonData) {
  const [employeeRoleData, setEmployeeRoleData] = useState([]);
  const GetEmployeeRole = () => {
    axios
      .get(`/GetEmployeeRole`)
      .then(response => {
        if (response.data.length > 0) {
          setEmployeeRoleData(response.data);
        }
      })
      .catch(error => { });
  };
  
  const { t } = useTranslation('Technician_Management');
  useEffect(() => {
    GetEmployeeRole();
  }, []);

  
  if (JsonData?.JsonData?.length === 0){
    return (
      <BottomNavigationAction 
      disabled={true}
      showLabel label={t('lblExport')} icon={<CloudDownloadIcon />} />
    )
  }


  var ExportData = JsonData.JsonData.map(item => {
    return {
      ServiceShopId: item.ServiceShopId,
      employeeRoleData:employeeRoleData.filter(i => i.Id === item.RoleId)[0]?.Dsc,
      UserType:item.UserTypes,
      TechnicianCode:item.TechnicianCode,
      Description:item.Description,
      UserName:item.UserName,
      Dsc:item.Dsc,
      Email:item.Email,
      Phone: item.Phones,
      Address: item.Address
    }
  });

  return (
    <>
      <Button
        size="small"
       variant="contained"
         color="primary"
         fullWidth
         endIcon={<CloudDownloadIcon />}
         onClick={() => exportToExcel(ExportData, 'EmployeeExport') }
       >
        {t('lblExport')}
       </Button>
    </>
  );
}

EmployeeExcelExport.propTypes = {

};

export default EmployeeExcelExport;
